(function () {
  'use strict';

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  ready(function () {
    /* ---------- Sticky header shadow ---------- */
    var hd = document.querySelector('.hd');
    if (hd) {
      var onScroll = function () {
        hd.classList.toggle('is-stuck', window.scrollY > 8);
      };
      onScroll();
      window.addEventListener('scroll', onScroll, { passive: true });
    }

    /* ---------- Mobile drawer ---------- */
    var drawer = document.getElementById('chDrawer');
    var openers = document.querySelectorAll('[data-ch-drawer-open]');
    var closers = document.querySelectorAll('[data-ch-drawer-close]');
    var lastFocus = null;

    function openDrawer() {
      if (!drawer) return;
      lastFocus = document.activeElement;
      drawer.classList.add('open');
      drawer.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      var first = drawer.querySelector('button, a');
      if (first) first.focus();
    }
    function closeDrawer() {
      if (!drawer) return;
      drawer.classList.remove('open');
      drawer.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }
    openers.forEach(function (b) { b.addEventListener('click', openDrawer); });
    closers.forEach(function (b) { b.addEventListener('click', closeDrawer); });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawer && drawer.classList.contains('open')) closeDrawer();
    });

    /* ---------- Mobile bottom bar: search focus ---------- */
    var mbarSearch = document.querySelector('[data-ch-search-focus]');
    if (mbarSearch) {
      mbarSearch.addEventListener('click', function () {
        var input = document.querySelector('#chDrawer input[type="search"]');
        if (input) {
          openDrawer();
          setTimeout(function () { input.focus(); }, 320);
        } else {
          window.location.href = '/search';
        }
      });
    }

    /* ---------- Mega menu keyboard support ---------- */
    document.querySelectorAll('.nv li.has-mega > a').forEach(function (a) {
      a.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowDown') {
          e.preventDefault();
          var first = a.parentElement.querySelector('.mega a');
          if (first) first.focus();
        }
      });
    });

    /* ---------- Countdown timers ---------- */
    document.querySelectorAll('[data-countdown]').forEach(function (el) {
      var end = new Date(el.getAttribute('data-countdown')).getTime();
      if (isNaN(end)) return;
      var units = {
        d: el.querySelector('[data-cd-d]'),
        h: el.querySelector('[data-cd-h]'),
        m: el.querySelector('[data-cd-m]'),
        s: el.querySelector('[data-cd-s]')
      };
      var pad = function (n) { return (n < 10 ? '0' : '') + n; };
      var tick = function () {
        var diff = Math.max(0, end - Date.now());
        var d = Math.floor(diff / 86400000);
        var h = Math.floor((diff % 86400000) / 3600000);
        var m = Math.floor((diff % 3600000) / 60000);
        var s = Math.floor((diff % 60000) / 1000);
        if (units.d) units.d.textContent = pad(d);
        if (units.h) units.h.textContent = pad(h);
        if (units.m) units.m.textContent = pad(m);
        if (units.s) units.s.textContent = pad(s);
        if (diff <= 0) {
          el.classList.add('ended');
          clearInterval(timer);
        }
      };
      tick();
      var timer = setInterval(tick, 1000);
    });

    /* ---------- Cart count sync (custom header + bottom bar) ---------- */
    function updateCartCounts(count) {
      document.querySelectorAll('[data-ch-cart-count]').forEach(function (el) {
        el.textContent = count;
        el.hidden = count === 0;
      });
    }
    if (window.subscribe && window.PUB_SUB_EVENTS && window.PUB_SUB_EVENTS.cartUpdate) {
      window.subscribe(window.PUB_SUB_EVENTS.cartUpdate, function () {
        fetch('/cart.js', { headers: { Accept: 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(function (cart) { updateCartCounts(cart.item_count); })
          .catch(function () {});
      });
    }

    /* ---------- Scroll reveal ---------- */
    var rv = document.querySelectorAll('.rv');
    if (!rv.length) return;
    if (!('IntersectionObserver' in window)) {
      rv.forEach(function (el) { el.classList.add('v'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) {
          en.target.classList.add('v');
          io.unobserve(en.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });
    rv.forEach(function (el) { io.observe(el); });

    /* Safety net: anything still hidden after 2.5s becomes visible */
    setTimeout(function () {
      document.querySelectorAll('.rv:not(.v)').forEach(function (el) {
        var r = el.getBoundingClientRect();
        if (r.top < window.innerHeight) el.classList.add('v');
      });
    }, 2500);
  });
})();
